module.exports = __webpack_public_path__ + "img/m_chalakov.04347909.jpg";